import React from "react"

export const GraphicLiteracyIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.8194 8.16648H11.7007C12.0039 8.16648 12.2497 8.41228 12.2497 8.71549V12.2497H3.30584V5.79889C3.30584 5.49568 3.55164 5.24988 3.85484 5.24988H5.97903V3.85484C5.97903 3.55164 6.22483 3.30584 6.52804 3.30584H9.27039C9.5736 3.30584 9.8194 3.55164 9.8194 3.85484V8.16648ZM4.47248 11.0831H5.97903V6.41652H4.58228C4.52164 6.41652 4.47248 6.46568 4.47248 6.52632V11.0831ZM7.14567 11.0831H8.65276V4.58228C8.65276 4.52164 8.6036 4.47248 8.54296 4.47248H7.25547C7.19483 4.47248 7.14567 4.52164 7.14567 4.58228V11.0831ZM9.8194 11.0831H11.0831V9.44292C11.0831 9.38228 11.0339 9.33312 10.9733 9.33312H9.8194V11.0831Z"
        fill="#37474F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.611 0C14.6804 2.44294e-05 15.5556 0.875174 15.5556 1.94458V13.611C15.5555 14.6804 14.6804 15.5555 13.611 15.5556H1.94458C0.875162 15.5556 6.15378e-06 14.6804 0 13.611V1.94458C0 0.875159 0.875159 0 1.94458 0H13.611ZM1.94458 1.16664C1.51948 1.16664 1.16664 1.51948 1.16664 1.94458V13.611C1.16665 14.0361 1.51948 14.3889 1.94458 14.3889H13.611C14.0361 14.3889 14.3889 14.0361 14.3889 13.611V1.94458C14.3889 1.51949 14.0361 1.16666 13.611 1.16664H1.94458Z"
        fill="#37474F"
      />
    </svg>
  )
}
